module.exports = __webpack_public_path__ + "static/media/Immediate_Icon.7f89ba66.svg";